"use client";

import Squares2X2Icon from "@heroicons/react/24/solid/Squares2X2Icon";
import { Button } from "@/components/ui/button";
import { useEffect, useRef, useState } from "react";
import { VENUE_TABS } from "@/@core/constants/venue-tabs";
import { useHash } from "react-hash-control";
import ScrollButtons from "./ScrollButtons";
import S3Image from "@/components/S3Image";
import dynamic from "next/dynamic";

const ModalGallery = dynamic(() => import("./ModalGallery"));
const ImageGallery = dynamic(() => import("./ImageGallery"));

interface props {
  datas: {
    url: string;
  }[];
  id: number;
  title: string;
}

export default function Images(props: props) {
  const [show, setShow] = useState(false);
  const [activeImage, setActiveImage] = useState(0);
  const [showGallery, setShowGallery] = useState(false);
  const activeId = useHash();

  useEffect(() => {
    if (activeId === "") {
      setShow(false);
    }
  }, [activeId]);

  const photoRef: any = useRef(null);

  return (
    <>
      {props.datas.length > 0 && (
        <div
          id={VENUE_TABS.PHOTOS}
          className="mt-6 relative flex flex-col gap-4 mb-6 lg:max-w-[895px] border rounded-[32px] px-4 pt-4 pb-2"
        >
          {show && (
            <ModalGallery
              venueTitle={props?.title}
              venueId={props.id}
              show={show}
              activeImageIndex={activeImage}
              closer={() => setShow(false)}
              images={props.datas}
            />
          )}

          {showGallery && (
            <ImageGallery
              venueTitle={props.title}
              venueId={props.id}
              open={showGallery}
              images={props.datas}
              closer={() => setShowGallery(false)}
            />
          )}

          <div className="flex bg-stone-50 rounded-[16px] py-1.5 px-2 justify-between items-center">
            <div className="flex gap-2">
              <Squares2X2Icon className="size-5 text-primary" />
              <h2 className="text-primary font-bold text-sm">Fotoğraflar</h2>
              <div className="py-[2px] px-[6px] text-xs bg-primary text-white font-[500] rounded-full">
                {props.datas.length}
              </div>
            </div>

            <Button
              variant="assistant"
              onClick={() => setShowGallery(true)}
              className="text-[10px] flex !h-6 justify-center items-center text-sm font-bold px-2 py-1"
            >
              <span className="hidden md:flex">Tüm Fotoğrafları Göster</span>

              <span className="flex md:hidden">Tüm Fotoğraflar</span>
            </Button>
          </div>

          <div
            ref={photoRef}
            className="scroll-smooth overflow-x-auto pb-2 custom-scrollbar flex"
          >
            <ScrollButtons
              refOfTheElement={photoRef}
              lengthOfDatas={props.datas.length}
            />

            <div className="flex gap-4 h-full">
              {props.datas.map((image, index) => {
                return (
                  <button
                    className="w-[300px] !h-[200px]"
                    key={index}
                    onClick={() => {
                      setShow(true);
                      setActiveImage(index);
                    }}
                  >
                    <S3Image
                      width={300}
                      height={200}
                      unoptimized
                      src={`/image/venue/${props.id}/photo/${image.url}?w=500&quality=60&height=356&format=webp&fit=contain`}
                      alt={props.title}
                      title={props.title}
                      loading="lazy"
                      onClick={() => {
                        setShow(true);
                        setActiveImage(index);
                      }}
                      className="object-cover h-[200px] rounded-[18px]"
                    />
                  </button>
                );
              })}
            </div>
          </div>
        </div>
      )}
    </>
  );
}
